var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ll-icon",class:{ stroke: _vm.stroke },domProps:{"innerHTML":_vm._s(_vm.iconType)}})
}
var staticRenderFns = []

export { render, staticRenderFns }